<template>
    <div class="staff-change-info-comment">
        <div class="placerholder">
            <slot>接入后展示员工个人形象员工可在【客户端-对外资料】中修改</slot>
            <com-per-icon v-if="open === 1" :icon-value="iconValue" @change="getIconValue"></com-per-icon>
        </div>
    </div>
</template>
<script>
import ComPerIcon from './compny-person-icon.vue';

export default {
    components: {
        ComPerIcon
    },
    props: {
        iconValue: {
            type: Boolean,
            default: true
        },
        open: {
            type: Number,
            default: 0
        }
    },
    methods: {
        getIconValue(val) {
            this.$emit('change', val);
        }
    }
};
</script>
<style lang="less">
.staff-change-info-comment {
    margin-top: 15px;
    box-sizing: border-box;
    padding: 20px;
    background: #f8f9fb;
    color: #78849e;
}
</style>
